import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const ReportsPage = lazy(() => import('../pages/ReportsPage'));
const StudentMarkSheetPage = lazy(() => import('../pages/reports/StudentMarkSheetPage'));
const ClassMarkReportPage = lazy(() => import('../pages/reports/ClassMarkReportPage'));
const ExamMarkReportPage = lazy(() => import('../pages/reports/ExamMarkReportPage'));
const MarkRangeReportPage = lazy(() => import('../pages/reports/MarkRangeReportPage'));
const ClassAttendanceReportPage = lazy(() => import('../pages/reports/ClassAttendanceReportPage'));
const DemographicsReportPage = lazy(() => import('../pages/reports/DemographicsReportPage'));
const BPLStudentsReportPage = lazy(() => import('../pages/reports/BPLStudentsReportPage'));
const SCSTStudentsReportPage = lazy(() => import('../pages/reports/SCSTStudentsReportPage'));
const HostelReportPage = lazy(() => import('../pages/reports/HostelReportPage'));
const LaundryReportPage = lazy(() => import('../pages/reports/LaundryReportPage'));
const HifzReportPage = lazy(() => import('../pages/reports/HifzReportPage'));

const ReportRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ReportsPage />} />
      <Route path="student-marks" element={<StudentMarkSheetPage />} />
      <Route path="class-marks" element={<ClassMarkReportPage />} />
      <Route path="exam-marks" element={<ExamMarkReportPage />} />
      <Route path="marks-range" element={<MarkRangeReportPage />} />
      <Route path="class-attendance" element={<ClassAttendanceReportPage />} />
      <Route path="gender" element={<DemographicsReportPage />} />
      <Route path="bpl-students" element={<BPLStudentsReportPage />} />
      <Route path="scst-students" element={<SCSTStudentsReportPage />} />
      <Route path="hostel" element={<HostelReportPage />} />
      <Route path="laundry" element={<LaundryReportPage />} />
      <Route path="hifz" element={<HifzReportPage />} />
    </Routes>
  );
};

export default ReportRoutes;
